export default {
  // sidebar
  sidebarAiGeneration: "Al Image Generation",
  replacement: "AI Try-On",
  sidebarAiArtface: "AI ArtFace",
  sidebarAiEmoji: "AI Emoji",
  sidebarGenerateRecord: "Generate Record",
  sidebarSignIn: "Sign-in / Sign-up",
  sidebarSignout: "SignOut",
  sidebarNotifications: "Notifications",
  sidebarLiked: "Liked List",
  sidebarOther: "Other",
  sidebarUserTools: "User Tools",
  sidebarCommunityFeed: "Community Feed",
  sidebarStartHere: "Start Here",
  sidebarInviteFriends: "Invite Friends",
  sidebarMannequinPerson: "Mannequin to Person",
  sidebarPersonSwap: "Person Swap",
  sidebarWearingAccessories: "Wearing accessories",
  sidebarProductSceneChange: "Product Scene Change",
  historyWorks: "History Works",

  // upload
  uploadTopic: "Magic Avatars",
  uploadTitle: "Upload photos and select styles to generate exclusive avatars.",
  uploadTips1: "Add 4-15 photos of the same person",
  uploadTips2: "Click here or drag and drop the photos to upload",
  uploadTips2Disabled: "You can continue to add after deleting pictures",
  uploadTips3: "By uploading photos you agree to our user",
  uploadTips5: "Add {num} photos to proceed",
  uploadTips7: "Upload limit reached, please select the avatar styles",
  uploadTerm: "term",
  createAvatar: "Generate Avatar",
  createAvatarStyle: "Continue with {num} style(s)",
  viewAll: "View All",
  goodExamples: "Good Examples",
  badExamples: "Bad Examples",
  goodExamplesTips:
    "Real-life photo or person on a mannequin, clothes properly displayed without obstructions, and the image is clear.",
  badExamplesTips:
    "Flat lay image, detailed image, picture is blurry and not clear.",
  photos: "Photos",
  selectGender: "Select your gender",
  female: "Female",
  male: "Male",
  uploading: "Importing photos...",
  insufficientPhotos: "Insufficient Photos",
  insufficientPhotosTips:
    "{num1} photo(s) failed to meet the requirements, please add at least {num2} more.",
  success: "Success",
  fail: "Fail",
  inadequatePhotos: "Please add at least {num} more",
  //select Style
  selectStyle: "Select Style",
  selectStyle1: "Select up to 5 styles",
  selectStyleTips: "Please select 1-5 styles.",
  // edit header
  myAccount: "My Account",
  cancel: "Cancel",
  delete: "Delete",

  // home
  home: "Home",
  faq: "FAQ",
  download: "Download",
  goToWebApp: "Go to web app",
  createNow: "To create",
  homeSlogon: "Create different styles of yourself through AI",
  homeEmjioSlogon: "Create different styles of yourself with AI technology",
  igniteCreativity: "Ignite creativity",
  igniteCreativityDesc: "Experience the future of fashion with FashionLabs.ai",
  betaBtn: "Apply for closed beta",
  helpContact: "Contact support@aispark.ai",
  aboutThePlatform: "About the platform",
  magicBanner1: "AI try-on",
  magicBanner1Desc:
    "AI automatic dressing, one model image applies to hundreds of products, upgrade your product images, saving shooting and time costs.",
  magicBanner2: "AI supermodel",
  magicBanner2Desc:
    "AI-generated models and backgrounds, upgrade your product images, saving shooting and time costs.",
  magicBanner3: "AI product image",
  magicBanner3Desc:
    "AI generates massive scene images, just a few clicks to generate e-commerce product images.",
  magicBanner4: "AI painting",
  magicBanner4Desc: "Create amazing original artwork in just a few minutes.",

  artFaceDesc:
    "🥳AI Avatar allows you to see different versions of yourself and get more personalized avatars.",
  emojiDesc:
    "🤪AI Emoji helps enrich and bring your avatars to life by adding various fun elements.",
  app: "APP",
  webApp: "Web App",
  appStore: "App Store",
  googlePlay: "Google Play",

  excellentTitle: "Excellent User Works",

  // common question
  subscribedTitle: "Manage Subscription",
  subscribedDesc: "Upgrade to unlock and unleash your artistic potential.",
  questionsTitle: "Frequently Asked Questions",
  questionSubTitle:
    "Can't find what you're looking for? email us at 📮support@fashionlabs.ai",
  question1: "How long does it take to generate an AI product model?",
  answer1:
    "In order to ensure better generation results, each task is expected to be completed within 4 hours. If there is a queue during peak hours, it is estimated to be completed within 24 hours. After completion, we will notify you via email.",
  question2: "What can be done to achieve the best result?",
  answer2:
    "Please follow the instructions and examples in the operation guide on the website to upload the images.",
  question3:
    "How long is the validity period of the points after subscription?",
  answer3:
    "The monthly bonus points given after subscribing are valid for 30 days. If they exceed 30 days, the system will automatically clear them and give a new cycle of bonus points.",
  question4: "How long is the validity period of points for a single purchase?",
  answer4:
    "The points purchased in a single purchase are valid for 1 year, and the remaining points after 1 year will be automatically cleared by the system.",
  question5: "What happens if all the points for a month are not used up?",
  answer5:
    "Unused points subscribed every month will not be carried forward to the next month unless you make a single purchase. The points for a single purchase are available within one year.",
  // footer
  help: "Help",
  aboutPlatform: "About the platform",
  protocolPolicy: "Privacy Policy",
  protocolTerms: "User Agreement",
  contact: "Contact",
  // homepage 中间五张彩色卡片切换swiper;
  homeCircleTitle1: "Create content for TikTok,Instagram...",
  homeCircleTitle2: "Create a Professional Profile Avatar",
  homeCircleTitle3: "Find your love with stunning selfies",
  homeCircleTitle4: "Create personalized emojis",
  homeCircleTitle5: "Play and win like a superhero",

  // login
  loginTitle: "Login",
  confirmChange: "Confirm Change",
  googleLogin: "Login with Google",
  fbLogin: "Login with Facebook",
  appleLogin: "Login with Apple",
  loginTips0: "I have read and agree",
  loginTips1: "By signing up, you agree to the",
  loginTips2: "Terms of Service",
  loginTips3: "and",
  loginTips4: "Privacy Policy.",
  switchAccount: "Skip",

  // recordList
  recordListTitle: "History Works",
  recordListTitleDesc:
    "Every time Al generates unique avatars, you will never have the same results!",
  recordImgNum: "images", //xx张
  recordGenerate: "Generating", //正在创建
  aiTypes0: "AI Avatars ",
  aiTypes1: "AI Emojis ",
  // recordAbout: "About", //预计还需
  // recordMinLeft: "min left",
  recordMinLeft: "About {num} min left",
  createBeatufy: "Creating beauty requires time and care...",
  recordCheckDetail: "View Details",
  btnStatusDesc0: "Refresh",
  btnStatusDesc1: "Create AI Emoji",
  btnStatusDesc2: "Regenerate",
  btnStatusDesc100: "Pay Now",
  payNum: "Purchase for {num}",
  noDataRecords: "No records yet",
  //edit/emoji
  editEmojiDesc:
    "Create first AI Avatars and then AI Emojis that bring your avatars to life.",
  createAIEmoji: "Create AI Emoji",
  quantity: "Quantity",
  downloads: "Downloads",
  downloadAll: "Download All",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  selected: "Continue with {num} Avatar(s)",
  works: "works",
  stepCreate: "Step 1: Create AI Avatar",
  step: "Step {num}",
  stepTips: "AI Avatars will be created first and then the AI Emojis",
  gotIt: "Got it",
  //homepage cardCircle
  cardArtStylesTopTitle: "50+ Realistic and artistic style",
  cardArtStylesBelowTitle: "suitable for any scene",
  uploadTerms: "terms",
  uploadTips4: "and",
  uploadPrivacy: "privacy policy",
  // Tabs
  Hot: "Hot",
  New: "New",
  // Generation page
  addNegativePrompt: "Add Negative Prompt",
  generation: "Generation",
  generationHistory: "Generation history",
  deleteAll: "Delete All",
  generateAgain: "Generate Again",
  numberOfImages: "Number of Images",
  imageDimensions: "Image Dimensions",
  imageToImage: "Image to Image",
  advanced: "Advanced",
  created: "Created",
  close: "Close",
  open: "Open",
  width: "Width",
  height: "Height",
  steps: "Steps",
  scale: "Guidance Scale",
  faces: "Face Fixing",
  uploadTips6: "Add {num} photos",
  uploadTips8: "Upload or drag and drop an image to use as input",
  uploadTips9: "Privacy not visible",
  uploadTips10: "Original reference image from the author",
  uploadTips11: "Drop an image to use as input",
  modelName1: "Midjourney Style",
  modelName2: "Portrait 1.0",
  modelName3: "Design Materials 1.0",
  modelName4: "Interior Design 1.0",
  estimatedMinutes: "Expected {num} minutes",
  generationErrorTips01: "Invalid parameter",
  generationErrorTips02:
    "Please adjust the prompt words and try again, or please try again later.",
  taskErrorTips01: "Generation failed",
  taskErrorTips02: "Task failed, please try again",
  delModalTitle: "Are you sure you want to deletethis generation?",
  delModalDesc: "If you confirm the generation will be impossible torecover.",
  inputPrompt: "Type a prompt",
  inputNegativePrompt:
    "Type what you don't want to see in the image(a negative prompt)",
  sameStyle: "Same Style",
  ForwardPromptDetails: "Forward prompt details:",
  ReversePromptDetails: "Reverse prompt details:",
  publishWork: "Publish Work",
  release: "Release",
  title: "Title",
  titlePlaceholder: "Please enter the title of the work",
  copySuccess: "Copy Success",
  wordsError:
    "Sorry, the information you entered contains sensitive words: {sum}, please re-enter.",
  wordsLimitation: "Generating, try again later.",
  iw: "Image weight",
  s: "Stylize",
  seed: "Seed",
  sampler: "Sampler",
  iwTips:
    "The generated result is compared to the reference image and description text for similarity.",
  sTips:
    "The smaller the numerical value, the more minimalistic and flat it is, and the larger the numerical value, the more complex it is.",
  samplerTips:
    "Schedulers manage the process of image generation. DPM++ schedulers bring better image quality. Euler and DDIM schedulers generate images faster.",
  seedTips:
    "Using a fixed random seed to maximize the degree of restoration when generating images next time.",
  stepsTips: "Higher steps - higher quality, but slower",
  scaleTips:
    "The higher the value, the more the outcome sticks to the text prompt.",
  // 登录注册
  signUp: "Sign Up",
  email: "Email",
  placeholderEmail: "Email address",
  password: "Password",
  confirmPassword: "Confirm Password",
  forgotPassword: "Forgot Password",
  resetTitle: "Reset Password",
  changeTitle: "Change your password.",
  validatePassword: "6-18 characters, numbers and letters",
  validatePasswordConfirm: "Passwords do not match. Please check and try again",
  revisePassword:
    "The link has been sent to {num}. Please click the link in your email to reset the password~",
  registerEmail:
    "The login link has been sent to {num}. Go activate your account now~",
  emailUsed: "This email has been linked to another account",
  emailNotActive:
    "Please activate your email by clicking on the link in your inbox.",
  IncorrectEmailPassword: "Incorrect email or password",
  accountActivationSuccessful: "Account activation successful",
  emailNotRegistered: "Email not registered",
  loginSuccess: "Login successful",
  // 订阅
  PayYearly: "Pay Yearly（20% OFF）",
  PayMonthly: "Pay Monthly",
  or: "Or",
  // 提示词分类
  style: "Style",
  art: "Art",
  view: "View",
  light: "Light",
  material: "Material",
  render: "Render",
  quality: "Quality",
  template: "Template",
  // 提示词多语言
  randomPrompt: "Random Prompt",
  featuredModels: "Featured Models",
  promptStudio: "Prompt Studio",
  prompt: "Prompt",
  promptPlaceholder: "Choose a prompt word or template",
  promptTips: "“+” is for emphasis, “-”is for de-emphasis.",
  pictureSize: "Picture Size",
  placeholderTxt: "Please enter the content",
  invitationCode: "Invitation Code",
  confirm: "Confirm",
  placeholderCode: "Please enter invitation code",
  moreSettings: "More settings",
  // invite friends
  myInvitationCode: "My invitation code",
  copyInvitationCode: "Copy invitation link",
  invitationRecord: "Invitation record",
  nickname: "Nickname",
  registrationTime: "Registration time",
  invitedNum: "Number of invited people",

  userTools: "User Tools",
  chooseClothing: "Choose Clothing",
  chooseModel: "Choose Model",
  excellentCases: "Excellent Cases",
  excellentCasesDesc:
    "Front 3D Image, Front Flat Image, Human Figure Image (Dummy Model)",
  incorrectCases: "Incorrect Cases",
  incorrectCasesDesc:
    "Non-front, non-wearing wrinkles, multiple clothing items",
  historyRecords: "History Records",
  noContentAvailable: "No content available",
  unpaidTitle: "Unpaid",
  generateNow: "Generate Now",
  removingBackground: "Removing background, please wait...",
  example: "Example",
  eraseTheShort: "Erase clothing lining",
  erase: "Erase",
  restore: "Restore",
  brushSize: "Brush Size",
  wear: "Wear",
  in: "In",
  generating: "Generating...",
  uploadDesc: "Click here or drag and drop the photos to upload",
  womenClothes: "Women Clothes",
  tops: "Tops",
  TShirt: "T-shirt",
  vests: "Vests",
  camisole: "Camisole",
  shortJjacket: "Short-sleeved jacket",
  longJacket: "Long-sleeved jacket",
  longSleeve: "Long-sleeve",
  hoodie: "Hoodie",
  shirt: "Shirt",
  bottoms: "Bottoms",
  shortSkirt: "Short skirt",
  longSkirt: "Long skirt",
  shorts: "Shorts",
  longPants: "Long pants",
  fullBody: "Full Body",
  shortDress: "Short-sleeved dress",
  trenchCoat: "Trench coat",
  strapDress: "Strap dress",
  longDress: "Long-sleeved dress",
  menClothes: "Men Clothes",
  vest: "Vest",
  stayTuned: "Stay tuned",
  next: "Next",
  uploadProduct: "Upload your new product",
  retry: "Retry",
  failure: "failure",
  failureTips: "The pictures are unqualified, please add them again",
  operationSuccessfully: "Operation successfully!",
  taskCreatedTip: "Task created successfully!",
  pleaseChooseClothing: "Please choose a clothing.",
  pleaseChooseModel: "Please choose a model.",
  estimatedMinutesCount: "Estimated 1-3 minutes",
  sendItAway: "Send it away and start uploading",
  fileFormatError: "File format error",
  createdLimitTips: "Generating, please try again later.",
  fileSizeError: "The image should be less than 10MB in size.",
  fileWidthHeightError: "The image dimensions should be greater than 512",
  fileNumError: "Upload up to {num} images maximum.",
  fileNumErrorMax: "Exceeding maximum quantity limit",
  step1: "Upload/Select Photos",
  step2: "Choose Models & Scenes",
  step3: "Generate Image",
  uploadImage: "Upload Image",
  uploadImageTips: "Click here or drag and drop the photos to upload",
  uploadImageTips2: "You can select up to 3 images",
  selectModel: "Select model",
  selectModelI1: "Female model",
  selectModelI0: "Male model",
  selectScene: "Select scene",
  select_indoor: "Indoor",
  select_outdoor: "Outdoor",
  select_solidbackground: "Solid background",
  again: "Reselect",
  return: "Undo",
  segmentDesc: "Click to select the content to be retained in the image",
  segmentDelDesc: "Data cannot be recovered after deletion",
  segmentCheckPicture: "Check the picture",
  segmentCheckPictureDesc:
    "You have {num} pictures that have not been processed,please check again",
  segmentImageError:
    "The image format does not meet the requirements, please upload again",
  segmentImageError1:
    "The image width and height need to be larger than 512px.",
  segmentImageError2: "Image Requirement: Width/Height ≤ 2",
  segmentUploadError:
    "uploading, please wait for the upload to complete before submitting",
  front: "Front",
  side: "Side",
  back: "Back",
  backBtn: "Back",
  pleaseUpload: "Please upload pictures",
  addNewProduct: "Add new product",
  totalImages: "Total {num} images",
  regenerate: "Regenerate",
  deletePicture: "Delete picture",
  deletePictureDesc: "Data cannot be recovered after deletion",
  add: "Add",
  againCreate: "Change model",
  startingUp: "AI starting up...",
  create: "Create",
  taskRetry: "Retry",
  deleteSeg: "Cancel all",
  processing: " In progress, please wait~",
  processingLast: "Queuing 😅， Please wait a moment~",
  uploadFail: " Upload failed, please upload again",
  classname_emotion: "Choose Emotion",
  watermark: " (watermark-free) ",

  myOrders: "My orders",
  orderDetails: "Order details",
  product: "Product",
  orderNumber: "Order Number",
  creationTime: "Creation Time",
  orderAmount: "Order Amount",
  orderStatus: "Order Status",
  operations: "Operations",
  refunded: "Refunded",
  noPaid: "No paid",
  paid: "Paid",
  myPoints: "My points",
  consumePoints: "Consume points",
  pointName: "Name",
  taskId: "Task id",
  orderId: "Order id",
  month: "month",
  invoiceApplication: "Invoice Application",
  invoiceIssued: "Invoice Issued",
  invoiceIssuance: "Invoice Issuance",
  addCustomer: "Add Customer Service by Scanning WeChat QR Code",
  fiveImages: "Five images",
  networkError: "Network error, please check your network",
  subscribeNow: "Subscribe Now",
  renewNow: "Renew Now",
  memberDiscount: "Subscribe to enjoy super low discounts",
  remainingPoints: "Remaining Points",
  pointsExpirationTime:
    "Points Expiration Date can be viewed on the Membership Subscription page",
  aiFashionPhoto: "AI Fashion Business Shooting",
  memberSubscription: "Membership Subscription",
  pointsPerImage: "Each image consumes",
  points: "Points",
  package: "Package",
  expirationTime: "Expiration date",
  monthlySubscription: "Monthly Subscription",
  annualSubscription: "Yearly Subscription",
  singlePurchase: "One-time Purchase",
  buyMorePoints: "Buy more points",
  payNow: "Pay now",
  off: "% OFF",
  phoneLogin: "Phone login/register",
  switchAccountTitle: "Switch Account",
  goCreate: "Go to Create",
  uploadRealPerson:
    "Upload real person photos or mannequin images. Get an AI model and photo retouching within 24 hours, saving you time, effort, and money on models, photographers, and location rentals.",
  uploadRealPersonTips1:
    "Upload clothing real person photos or mannequin images",
  uploadRealPersonTips2: "Upload reference images for the desired style",
  uploadRealPersonTips3: "Receive retouched content and download it",
  emailLogin: "Email Login",
  inputPhone: "Please enter your phone number",
  inputCode: "Please enter the Code",
  loginRegister: "Log in/Register",
  sendCode: "Send Code",
  phoneError: "Please enter a valid phone number",
  sendCodeSuccess: "Sent ({num}s)",
  codeSendSuccess: "Verification code sent successfully",
  codeSendError: "Frequent operations, please try again later",
  codeSendFail: "Failed to send verification code, please try again later",
  codeError: "Incorrect verification code",
  backToWorkbench: "Back to Workbench",
  buyMorePointsTitle: "Buy More Points",
  buyMorePointsDesc:
    "*Valid for 30 days, please use it within the valid period～",
  uploadMaterial: "Upload Materials",
  uploadReference: "Upload Reference Images",
  downloadRefinement: "Download Retouching",
  uploadRealPersonTitle:
    "Upload Clothing Real Person Photos or Mannequin Images",
  uploadRealPersonDesc: "Drag and drop images here or click to upload",
  uploadRealPersonDesc2: "You can select up to {num} images",
  uploadReferenceTitle: "Upload Reference Images for Desired Style",
  uploadReferenceDesc: "If not uploaded, random generation will be used～",
  contactUs: "Contact Us",
  addCustomerService: "Scan to Add Exclusive Customer Service",
  pointsInsufficient: "Insufficient Points",
  nineYuan: "¥9.9",
  pointsConsumption: "Consume {num} Points",
  immediatelyGenerate: "Generate Now",
  countdown: "Countdown {num}s",
  exchangeCode: "Redeem Code",
  inputExchangeCode: "Please Enter Redemption Code",
  exchangeCodeTips: "Redemption code cannot contain spaces",
  pointsExchange: "Points Exchange",
  scanCodePayment: "Scan to Pay",
  aiModelRefinement: "{num} yuan AI Model Refinement",
  pointsExchangeModel: "Exchange {num} Model Images for Points",
  currentPoints: "Current Points",
  immediatelyExchange: "Redeem Now",
  useExchangeCode: "Use Redemption Code",
  estimated: "Estimated time: {hours} hours {minutes} minutes",
  noInvitationCode: "Don't have an invitation code?",
  wechatScanCode:
    "Scan with WeChat to add customer service and get an invitation code",
  uploadReferenceTitle2:
    "Upload References (What kind of effect do you want? You can upload up to 5 images, optional)",
  inputDescription: "Enter Description",
  inputDescriptionTips:
    "Enter your requirements, for example: You'd like a European or American female model in a beach setting.",
  face_1: "Male Model",
  face_2: "Female Model",
  face_type_1: "Caucasian Skin",
  face_type_2: "Asian Skin",
  face_type_3: "African Skin",
  notChangeModel: "No model change",
  invitationCodeError: "Invitation Code Error",
  pointsInsufficientTips: "Insufficient points, please recharge and try again",
  pleaseSelectModel: "Please select a model",
  processing1: "Estimated 2 hours",
  processingDesc1: "😘 In progress, please wait~",
  processing2: "Many businesses in the queue",
  processingDesc2: "😘 It will take a little longer~",
  processing3: "Packaging in progress, please wait",
  processingDesc3: "🤗️ You will receive an SMS notification once it's done~",
  processingDescAi3:
    "🤗️ You will receive an email notification once it is completed.",
  userId: "User ID",
  paymentTime: "Payment Time",
  noOrder: "There are no orders for this user.",
  aiProduct: "AI Product Images",
  uploadProductTitle: "Upload Product Images",
  tryThese: "Try These",
  ratio: "Image Proportions",
  segmentation: "Detailed Image Extraction",
  canvasTips:
    "The canvas area represents the final display area, and objects can be rotated to adjust their positions.",

  homeBannerTitle1:
    "Dedicated to building an AI tool that enables e-commerce businesses to use AI technology at a low cost",
  homeBannerTitle2: "Efficiently generate",
  homeBannerTitle3: "commercial shooting tools",
  homeBannerCate1: "Fashion Model Images",
  homeBannerCate2: "Product Display Images",
  homeBannerCate3: "Handheld Product Images",
  tryItNow: "Try it now",
  tryTip: "First experience ￥9.9/ time",
  modelsAl: "Swap Fashion Models",
  ordinaryToProfessional:
    "An ordinary person upgrades to a professional model.",
  changeModels:
    "Change models based on gender, ethnicity, age, expression and more",
  mannequinToPerson: "Mannequin to Person",
  convertMannequins: "Convert mannequins to people wearing your garments",
  headlessImages: "Magically add faces for headless images",
  autoGenerateFaces:
    "Automatically generate faces even if your image is cropped",
  fullBodyModels: "Generate full-body models from half-body images.",
  autoGenerateOutfit:
    "Even if the original image is cropped, the complete outfit will still be automatically generated.",
  productSceneChange: "Product Scene Change",
  swapBackground: "Swap the background of a product",
  moreAITools: "More AI tools",
  removeBackground: "Remove Background",
  retouch: "Retouch",
  imageUpscaler: "Image Upscaler",
  whyChooseFashionLabs: "Why Choose FashionLabs?",
  shortenTimeToMarket: "Shorten time to market",
  quickProductUpdates:
    "Help you quickly update products and launch advertising campaigns in a timely manner",
  reduceShootingCosts: "Reduce shooting costs",
  saveTraditionalCosts:
    "Save traditional shooting costs and obtain high-quality results at a low cost",
  boostSalesConversion: "Boost sales conversion",
  stayAheadOfCompetitors:
    "Stay ahead of competitors, leave a brand impression on customers, and drive sales growth",
  customerCaseStudies: "Customer case studies",
  startCreatingProfessionalImages:
    "Start creating professional product photography images.",
  limitedTimeOffer: "Limited time offer: Only 14 days left",
};
